document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ps-wrap[data-layout="slider"]').forEach(function (wrap) {
    var track = wrap.querySelector('.ps-slider-track');
    var prev = wrap.querySelector('.ps-nav--prev');
    var next = wrap.querySelector('.ps-nav--next');
    if (!track || !prev || !next) return;

    function scrollAmount() {
      var card = track.querySelector('.ps-card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 16);
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
});
